export default __webpack_public_path__ + "static/media/NewInstalls.14a3400f.jpg";